<script setup>
  import { ref, computed, onMounted, watch } from 'vue';
  import WindGraphMultiStationListItem from '@/components/WindGraphMultiStationListItem.vue';

  const emit = defineEmits(['multi-station-list:change']);

  const props = defineProps({
    spots: {
      type: Array,
      required: true
    }
  });

  const stationColors = [
    "375eba",
		"32cd32",
		"980998",
		"8fbc8f",
		"b0778d",
		"d2b48c",
		"ff0000",
		"6a5acd",
		"ff8c00",
		"ffd700",
		"423bff",
		"00ff00",
		"9400d3",
		"21ff9b",
		"dc143c",
		"00ffff",
		"adff2f",
		"00bfff",
		"ff6347",
		"c877e0",
		"ff00ff",
		"1e90ff",
		"f5de99",
		"ffff54",
		"dda0dd",
		"90ee90",
		"87ceeb",
		"ff1493",
		"ffa07a",
		"7fffd4",
		"ff69b4",
		"fffacd",
		"e0ffff",
		"ffc0cb",
		"808080",
		"c0c0c0",
		"2f4f4f",
		"556b2f",
		"a0522d",
		"228b22",
		"800000",
		"090949",
		"808000",
		"3cb371",
		"b8860b",
		"008b8b",
		"4682b4",
		"d2691e",
		"9acd32",
		"cd5c5c"		
  ]

  const allStations = ref([]);
  const activeStations = computed(() => allStations.value.filter(station => station.active));
  const activeStationsTextList = computed(() => activeStations.value.map(station => station.station_id).join(','));
  const activeStationColors = computed(() => activeStations.value.map(station => station.color).join(','));
  const spotIdList = computed(() => props.spots.map(spot => spot.spot_id).join(','));
  
  function handleStationActiveChange(event) {
    const station = allStations.value.find(station => station.station_id === event.station_id);
    if (station) {
      station.active = event.active;
    }

    dispatchMultiStationListChange();
  }

  function addMetaDataToStation(station, spot) {
    station.mesonet_name = spot.mesonet_name;
    station.name = spot.name;
    station.data_names = spot.data_names;
    station.color = `0x${stationColors[allStations.value.length]}`;
    station.active = true;
  }

  function dispatchMultiStationListChange() {
    const details = { stationList: activeStationsTextList.value, spotList: spotIdList.value, colors: activeStationColors.value };

    emit('multi-station-list:change', details);
  }
  
  watch(() => props.spots, (newSpots) => {
    const newAllStationsList = [];
    
    newSpots.forEach(spot => {
      spot.stations.forEach(station => {
        const foundStation = allStations.value.find(s => s.station_id === station.station_id);
        
        if (!foundStation) {
          addMetaDataToStation(station, spot);
          
          newAllStationsList.push(station);
        } else {
          newAllStationsList.push(foundStation);
        }
      });
    });
    
    allStations.value = newAllStationsList;
    dispatchMultiStationListChange();
  });
  
  onMounted(() => {
    props.spots.forEach(spot => {
      spot.stations.forEach(station => {
        addMetaDataToStation(station, spot);
        
        allStations.value.push(station);
      });
    });

    dispatchMultiStationListChange();
  });
</script>

<template>
  <div class="jwx-multi-station-list">
      <WindGraphMultiStationListItem 
        @station-active:change="handleStationActiveChange"
        v-for="(station, i) in allStations" 
        :key="station.station_id" 
        :station="station"
        :color="stationColors[i]"
        :activeStationCount="activeStations.length"
      />
  </div>
</template>